/**
 * Survey "How will you use Corca?" options.
 * Kept in a separate file so store and other non-page code can import it
 * without pulling in the survey-use page bundle (AuthLayout, RequireAuth, etc.).
 */
export enum SurveyUseOption {
  Personal = "personal",
  AsATeam = "asATeam",
}
